import React from 'react';
import DepartmentTaskManager from '../../components/DepartmentTaskManager';

const SalesTaskManager = () => {
  return <DepartmentTaskManager department="SALES" />;
};

export default SalesTaskManager;
